/**
 * Instructions shown before the Information Sharing (fake news) task.
 *
 * IMPORTANT: Same design principles as EmailTaskIntro after the instrument audit:
 *   - NO priming language ("fake news", "misinformation", "disinformation")
 *   - Neutral action labels: Share / Skip / Flag
 *   - No evaluative language in button descriptions
 */

import React from 'react';
import { useNavigate } from 'react-router-dom';

const InformationSharingTaskIntro: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="instructions-page" style={{ maxWidth: '800px', margin: '0 auto', padding: '2rem' }}>
      <div className="instruction-section" style={{ backgroundColor: '#f8f9fa', padding: '2rem', borderRadius: '8px' }}>
        <h1 style={{ fontSize: '1.5rem', marginBottom: '1rem' }}>News Article Evaluation</h1>

        <p style={{ fontSize: '15px', lineHeight: '1.8', marginBottom: '1rem' }}>
          In this study you will read <strong>four short news articles</strong> from different sources,
          presented the way they might appear online. Please read each one at your own pace, as you
          normally would.
        </p>

        <h2 style={{ fontSize: '1.1rem', marginBottom: '0.5rem' }}>For each article you will:</h2>
        <ol style={{ fontSize: '15px', lineHeight: '1.8', marginLeft: '1.25rem', marginBottom: '1.25rem' }}>
          <li>Read the article.</li>
          <li>Answer a set of rating questions about it (your impressions of the article, the source, and the content).</li>
          <li>Indicate what you would do with it if you saw it on social media: <strong>Share</strong>, <strong>Scroll&nbsp;past</strong>, or <strong>Flag</strong>.</li>
        </ol>

        <div style={{ display: 'flex', justifyContent: 'center', gap: '1rem', margin: '1rem 0 1.25rem' }}>
          {['📤 Share', '➡️ Scroll past', '🚩 Flag'].map(o => (
            <span key={o} style={{
              display: 'inline-flex', alignItems: 'center', gap: '6px',
              padding: '8px 14px', border: '1px solid #e1e5e9', borderRadius: '6px',
              background: '#ffffff', fontSize: '13px'
            }}>{o}</span>
          ))}
        </div>

        <p style={{ fontSize: '14px', lineHeight: 1.7, color: '#444' }}>
          There are no right or wrong answers — we are interested in your honest reactions. The
          articles cover a range of current topics, and some you may agree with more than others.
        </p>
      </div>

      <div style={{ textAlign: 'center', marginTop: '2rem' }}>
        <button
          onClick={() => navigate('/info-sharing-task')}
          style={{
            padding: '12px 40px', fontSize: '16px', fontWeight: '600',
            backgroundColor: '#0078d4', color: 'white', border: 'none',
            borderRadius: '6px', cursor: 'pointer'
          }}
        >
          Start Evaluating Articles
        </button>
      </div>
    </div>
  );
};

export default InformationSharingTaskIntro;
